import { render } from "./RewardsSection.vue?vue&type=template&id=273d80bb&scoped=true"
import script from "./RewardsSection.vue?vue&type=script&lang=js"
export * from "./RewardsSection.vue?vue&type=script&lang=js"

import "./RewardsSection.vue?vue&type=style&index=0&id=273d80bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273d80bb"]])

export default __exports__